module.exports = __webpack_public_path__ + "img/caret-down-fill-nor.75d3b362.svg";